// @flow

import type { Organization } from '@gandi/redux-organization';

import type { OrganizationFormData } from '../types';

export const getFilteredDataForPATCH: ({
  /** data from the form submitting */
  data: OrganizationFormData,
  /** dirtyFields from the form
   *  the react-hook-form formState.dirtyFields */
  dirtyFields: { [$Keys<OrganizationFormData>]: true },
}) => Partial<OrganizationFormData> = ({ data, dirtyFields }) => {
  // first only select the fields which have been modified
  const dirtyData: Partial<OrganizationFormData> = {};

  Object.keys(dirtyFields).forEach(key => {
    const value = data[key];
    if (value === undefined) return;
    // $FlowFixMe[incompatible-type]
    dirtyData[key] = value === '' ? null : value; // explicitly set to null the fields that are empty, so that they can be unset on the server
  });

  return dirtyData;
};

export function getEnrichedDataForPOST({
  ownerOrganization,
  cartId,
  label,
}: {
  ownerOrganization: ?Organization,
  cartId: string,
  label: string,
}): {
  invitation: {
    params: { billed_orgname: string | string, cart_id: string },
    workflow: string,
  },
  team: { name: string, profile: string, ... },
} {
  return {
    invitation: {
      workflow: 'buy4me',
      params: {
        // $FlowFixMe[incompatible-use]
        billed_orgname: ownerOrganization.name,
        cart_id: cartId,
      },
    },
    team: { profile: 'admin', name: label },
  };
}
